let socket = null;
let reconnectTimer = null;
let heartbeatTimer = null;

export const websocketMiddleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  switch (action.type) {
    case "websocket/wsConnect": {

      if (socket && socket.readyState !== WebSocket.CLOSED) return;

      socket = new WebSocket(action.payload);

      socket.onopen = () => {
        dispatch({ type: "websocket/wsConnected" });

        // 开启心跳
        heartbeatTimer = setInterval(() => {
          if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: "ping" }));
          }
        }, 60000); // 每分钟
      };

      socket.onmessage = (event) => {
        dispatch({
          type: "websocket/wsMessage",
          payload: JSON.parse(event.data),
        });
      };

      socket.onclose = () => {
        dispatch({ type: "websocket/wsDisconnected" });

        // 清理
        socket = null;
        clearInterval(heartbeatTimer);

        reconnectTimer = setTimeout(() => {
          dispatch({ type: "websocket/wsConnect", payload: action.payload });
        }, 3000);
      };

      socket.onerror = () => {
        socket.close();
      };

      break;
    }

    case "websocket/wsDisconnect": {
      if (socket) {
        socket.close();
        socket = null;
      }

      clearTimeout(reconnectTimer);
      clearInterval(heartbeatTimer);

      break;
    }

    case "websocket/wsSend": {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(action.payload));
      }
      break;
    }

    default:
      return next(action);
  }

  return next(action); 
};